/*
 * PIN recovery is only for pedestrian-PIN hotels: the "Pinpad Access" feature
 * on the Inner Range provider with pedestrian_mode switched on. This only
 * decides what Console shows; the API checks the same flag, and the user's
 * role at the hotel, on every lookup and action.
 */
export const PINPAD_ACCESS_FEATURE = "Pinpad Access";
export const INNER_RANGE_PROVIDER = "Inner Range";

function parseConfiguration(configuration) {
  if (typeof configuration !== "string") return configuration || null;
  try {
    return JSON.parse(configuration);
  } catch {
    return null;
  }
}

export function isPinRecoveryEnabled(facility) {
  const record = facility?.featureFacilityProviderConfigurations?.find(
    (item) =>
      item?.feature?.name === PINPAD_ACCESS_FEATURE &&
      item?.provider?.name === INNER_RANGE_PROVIDER,
  );
  return parseConfiguration(record?.configuration)?.pedestrian_mode === true;
}
